import { render, staticRenderFns } from "./CurriculumCopyPop.vue?vue&type=template&id=327eab3c"
import script from "./CurriculumCopyPop.vue?vue&type=script&lang=js"
export * from "./CurriculumCopyPop.vue?vue&type=script&lang=js"
import style0 from "./CurriculumCopyPop.vue?vue&type=style&index=0&id=327eab3c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports